"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _registration = require('redux/actions/registration');

var _voice_code = require('redux/actions/voice_code');

var _BaseForm2 = require('components/BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegistrationConfirm = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        errorsList: state.registration.errorsList,
        preload: state.registration.preload,
        errorCode: state.registration.errorCode,
        settings: state.setting,
        lang: state.lang
    };
}, { confirmRegistration: _registration.confirmRegistration, resetVoiceCode: _voice_code.resetVoiceCode, resetError: _registration.resetError }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(RegistrationConfirm, _BaseForm);

    function RegistrationConfirm(props, context) {
        (0, _classCallCheck3.default)(this, RegistrationConfirm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RegistrationConfirm.__proto__ || (0, _getPrototypeOf2.default)(RegistrationConfirm)).call(this, props, context));

        _this.showOuterAlert = function (alert) {
            _this.setState({ outerAlert: alert });
        };

        _this.state = {
            smsCode: '',
            emailCode: '',
            outerAlert: null
        };
        return _this;
    }

    (0, _createClass3.default)(RegistrationConfirm, [{
        key: 'onSubmit',
        value: function onSubmit(event) {
            (0, _get3.default)(RegistrationConfirm.prototype.__proto__ || (0, _getPrototypeOf2.default)(RegistrationConfirm.prototype), 'onSubmit', this).call(this, event);

            if (this.isValid()) {
                var formData = this.props.formData;

                var codes = {};

                if (this.state.smsCode) {
                    codes['sms_code'] = this.state.smsCode;
                }

                if (this.state.emailCode) {
                    codes['email_code'] = this.state.emailCode;
                }

                this.props.confirmRegistration((0, _extends3.default)({
                    shopId: this.props.settings.shopId
                }, formData, codes));
                this.props.resetVoiceCode();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetError();
            this.props.resetVoiceCode();
        }

        /**
         * Валидация по всем методам проверки
         * @returns {boolean}
         */

    }, {
        key: 'isValid',
        value: function isValid() {
            //return this.state.smsCode.length > 0;
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('RegistrationConfirm', null, { folderName: "Registration/RegistrationConfirm" });

            return _react2.default.createElement(View, {
                smsCode: this.state.smsCode,
                emailCode: this.state.emailCode,
                changeField: this.changeField,
                formData: this.props.formData,
                onSubmit: this.onSubmit,
                disabledSubmit: !this.isValid(),
                preload: this.props.preload,
                errorsList: this.props.errorsList,
                showOuterAlert: this.showOuterAlert,
                outerAlert: this.state.outerAlert,
                errorCode: this.props.errorCode,
                settings: this.props.settings,
                lang: this.props.lang
            });
        }
    }]);
    return RegistrationConfirm;
}(_BaseForm3.default), _class2.propTypes = {
    changeField: _react.PropTypes.func.isRequired,
    formData: _react.PropTypes.object.isRequired,
    lang: _react.PropTypes.object
}, _temp)) || _class);
exports.default = RegistrationConfirm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationConfirm/RegistrationConfirm.jsx
// module id = 1746
// module chunks = 0